import API from 'services/api';

export const guestRegistrationOnEVisitor = (payload: string[]) =>
  API.post('/api/accommodation/guests/evisitor', payload);
